export default "__VITE_ASSET__99ee5a2f__"